import React, { useCallback } from 'react'

import { BridgeService } from '@/services'
import { DeepLinksPF, DeepLinksPJ, requestAnalytics } from '@/services/bridge'

import { SEVEN_PHRASES } from './constants'
import * as S from './styles'
import { useTypewriter } from './useTypewriter'

interface ISeven {
  isAppPJ?: boolean
}

export const Seven = ({ isAppPJ = false }: ISeven) => {
  const { text, phraseIndex } = useTypewriter(SEVEN_PHRASES)

  const handleClick = useCallback(() => {
    requestAnalytics('CliqueSeven', {
      content_name: SEVEN_PHRASES[phraseIndex],
      origin: 'INFORME_RENDIMENTOS',
    })

    const deepLink = isAppPJ ? DeepLinksPJ.SMART_SEARCH : DeepLinksPF.SMART_SEARCH

    BridgeService.navigateDeepLink(`${deepLink}?theme=TORANJA&feature=CORE_CHAT_SMART_SEARCH`)
  }, [isAppPJ, phraseIndex])

  return (
    <S.Container>
      <S.Button type="button" onClick={handleClick} data-testid="seven-entry">
        <S.Sparkle aria-hidden="true">✦</S.Sparkle>
        <S.LabelWrapper aria-live="polite">
          <S.Label>{text}</S.Label>
        </S.LabelWrapper>
      </S.Button>
    </S.Container>
  )
}
